import { useCallback, useState } from 'react';
import { reportUserAPI } from '../../../../api/reports';
import { UserReportTypes } from '../../../../utils/types';
import { useSnackbar } from 'notistack';

export const useReportUserDialog = (eventId: string | undefined) => {
    const [isReportLoading, setIsReportLoading] = useState(false);
    const [error, setError] = useState(null);
    const { enqueueSnackbar } = useSnackbar();

    const reportUser = useCallback(
        async (userId: string, type: UserReportTypes) => {
            if (eventId) {
                try {
                    setIsReportLoading(true);
                    await reportUserAPI(eventId, userId, type);
                    enqueueSnackbar('User reported successfully.', {
                        variant: 'success',
                    });
                } catch (error: any) {
                    console.warn(error);
                    setError(error);
                    enqueueSnackbar('Error while reporting user.', {
                        variant: 'error',
                    });
                }

                setIsReportLoading(false);
            }
        },
        [eventId]
    );

    return {
        error,
        reportUser,
        isReportLoading,
    };
};
